import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../../../config/envs';
import { generateTraceId } from '../../../helpers';

const ADMIN_BASE_URL = config.app.adminBaseUrl;

export class CourtesySubscriptionsAPI {
  static async createForNewClient(payload) {
    try {
      const response = await axios.post(
        `${ADMIN_BASE_URL}/courtesy-subscriptions`,
        payload,
      );
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Não foi possível criar a cortesia',
      );
      throw error;
    }
  }

  static async createForExistingClient(clientId, payload) {
    try {
      const response = await axios.post(
        `${ADMIN_BASE_URL}/courtesy-subscriptions/clients/${clientId}`,
        payload,
        { headers: { 'x-trace-id': generateTraceId() } },
      );
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Não foi possível criar a cortesia',
      );
      throw error;
    }
  }
}
